import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/shell/session'
import { z } from 'zod'
import { Headphones } from 'lucide-react'
import { SupportInboxScreen } from '@/screens/platform/SCR-189-support-inbox'

// SCR-189 Support inbox (platform area, super admins only).
export const Route = createFileRoute('/_app/platform/support')({
  beforeLoad: requireSuperAdmin,
  staticData: { screen: { id: 'SCR-189', title: 'Support inbox', group: 'Platform', order: 4, platform: true, description: 'Support requests from every organisation: reply, assign, add internal notes.', icon: Headphones } },
  validateSearch: z.object({
    ticket: z.string().max(100).optional().catch(undefined),
    status: z.enum(['active', 'all', 'open', 'waiting_on_customer', 'waiting_on_adya', 'resolved']).optional().catch(undefined),
    assignee: z.enum(['any', 'me', 'unassigned']).optional().catch(undefined),
    q: z.string().max(100).optional().catch(undefined),
  }),
  component: SupportInboxScreen,
})
